export { AtnRulesTabComponent as Component } from './rules-tab.component'
